<template>
<div class="box-labour">
    <div class="box-box">
        <div class="nav">
            <router-link to="AdministrativeHome"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
            会议预订
            <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
        </div>
        <div class="issueContent">
            <!-- <div>
                <p class="titleClass titleCotent">1. 学校相关资质使用申请流程</p>
                <img src="../../assets/you.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent0()">
            </div> -->
            <!-- <div>
                <p class="titleClass">2. 会议相关预订申请流程</p>
                <img v-show="addShowJia" src="../../assets/jia.png" alt="" class="ImgClass" @click="addGetJia()">
                <img v-show="addShowXia" src="../../assets/xia.png" alt="" class="ImgClass" @click="addGetXia()">
            </div>  -->
            <div v-for="item in dataList" :key="item.id">
                <p class="titleClass" id="titleCotent">{{item.title}}</p>
                <img src="../../assets/you.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent(item.id)">
            </div>
            <!-- <div>
                <p class="titleClass titleCotent">3. 合同与印章申请流程</p>
                <img v-show="addShowJia1" src="../../assets/jia.png" alt="" class="ImgClass" @click="addGetJia1()">
                <img v-show="addShowXia1" src="../../assets/xia.png" alt="" class="ImgClass" @click="addGetXia1()">
            </div>
            <div v-for="(item,i) in dataList1" :key="i" v-show="showContent1">
                <p class="titleClass" id="titleCotent">{{item.title}}</p>
                <img src="../../assets/dian.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent1(i)">
            </div> -->
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            addShowJia: true,
            addShowXia: false,
            showContent: false,
            addShowJia1: true,
            addShowXia1: false,
            showContent1: false,
            dataList: [{
                    title: "1. 预订前提",
                    id: "36"
                },{
                    title: "2. 会议室的预定流程",
                    id: "35"
                },{
                    title: "3. 教室的预订流程",
                    id: "33"
                },
                {
                    title: "4. 会议配套周边预订流程",
                    id: "34"
                }
            ],
            dataList1: [{
                    title: "2.1 合同申请流程"
                },{
                    title: "2.2 印章申请流程"
                },]
        };
    },
    methods: {
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "1003"
                }
            })
        },
        addGetContent(i){
            if(i == 33){
                this.$router.push({name:"Administrative3",params:{code:'13'}})
            }else if(i == 34) {
                this.$router.push({name:"Administrative4"})
            } else if(i == 35){
                this.$router.push({name:"Administrative8"})
            } else if(i == 36) {
                this.$router.push({name:"Administrative2"})
            }
        },
        addGetJia() {
            this.addShowXia = true;
            this.showContent = true;
            this.addShowJia = false;
            if (this.addShowXia1 == true || this.addShowXia2 == true) {
                this.addShowXia1 = false;
                this.showContent1 = false;
                this.addShowJia1 = true;
                this.addShowXia2 = false;
                this.showContent2 = false;
                this.addShowJia2 = true;
            }
        },
        addGetXia() {
            this.addShowXia = false;
            this.showContent = false;
            this.addShowJia = true;
        },
    }
};
</script>

<style scoped>
.box-labour {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
}

.box-box {
    background: rgba(244, 244, 244, 1);
}
.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.issueContent {
    width: 90%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.3);
    border-radius: 10px;
    overflow: hidden;
}

.issueContent div {
    width: 100%;
    height: 56px;
    border-bottom: 1px solid #ededed;
}

.issueContent div:last-child {
    border-bottom: 0;
}

.issueContent div .titleClass {
    width: 63%;
    float: left;
    color: #838383;
    margin: 18px 0 18px 24px;
}

.issueContent div .ImgClassDian {
    width: 18px !important;
}

.issueContent div #titleCotent {
    width: 80% !important;
    margin-left: 33px !important;
    font-size: 15px;
}

.issueContent div img {
    width: 21px;
    float: right;
    margin: 18px 10px 18px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Administrative/administrative.vue